export const formatFileName = (text) => {
    if(text){
        return text.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replaceAll('-', '').replaceAll(" ", "")
    }

    return text
}